import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import { CountdownProps, CountDownSizes } from './types'

import countdownFn from 'mondrian-vanilla/core/components/Countdown/countdown.js'

const config = {
  types: ['block'],
  modifiers: ['sm', 'md', 'lg'],
  states: []
}

interface MondrianWindow extends Window {
  MondrianVanilla: {
    scripts: {
      Calendar: any
    }
  }
}

declare let window: MondrianWindow

export default function Countdown(props: CountDownSizes & CountdownProps) {
  const {
    startDate,
    title = 'Esta oferta termina em:',
    endDate,
    tag,
    lg,
    block,
    showOnlyHours,
    splitTime,
    hideOnEnd,
    hideOnEndId
  } = props

  const countdownRef = React.useRef(null)
  const initialDate = Date.parse(startDate.toString())
  const finalDate = Date.parse(endDate.toString())

  React.useEffect(() => {
    countdownRef.current && countdownFn(countdownRef.current)
  }, [countdownRef])

  return (
    <div
      ref={countdownRef}
      className={`${resolveProps(props, config, 'Countdown').trim()}`}
      data-mdn-start-date={initialDate}
      data-mdn-end-date={finalDate}
      data-mdn-hide-on-end={hideOnEnd}
      data-mdn-hide-on-end-id={hideOnEndId}
      data-mdn-show-only-hours={showOnlyHours}
      data-mdn-split-time={splitTime}
    >
      {lg ? (
        <>
          <div className="mdn-Countdown-tag">{tag}</div>
          <div className="mdn-Countdown-content">
            <div className="mdn-Countdown-content-title">{title}</div>
            <div className="mdn-Countdown-timer"></div>
          </div>
        </>
      ) : block ? (
        <>
          <div className="mdn-Container">
          <div className="mdn-Countdown-title">{title}</div>
            <div className="mdn-Countdown-content">
              
              <div className="mdn-Countdown-timer"></div>
            </div>
          </div>

          <div className="mdn-Countdown-bar">
            <div className="mdn-Countdown-bar-progress"></div>
            <span className="mdn-Countdown-bar-progress-value"></span>
          </div>
        </>
      ) : (
        <>
          <div className="mdn-Countdown-content-title">{title}</div>
          <div className="mdn-Countdown-timer"></div>
        </>
      )}
    </div>
  )
}
